// Device Reducer
import { createReducer, on } from '@ngrx/store';
import { DeviceState, initialDeviceState } from './device.state';
import * as DeviceActions from './device.actions';

export const deviceReducer = createReducer(
  initialDeviceState,

  // Set current device
  on(DeviceActions.setCurrentDevice, (state, { deviceId }) => ({
    ...state,
    deviceId,
    error: null,
  })),
  on(DeviceActions.clearCurrentDevice, () => ({
    ...initialDeviceState,
  })),

  // Load Identity
  on(DeviceActions.loadIdentity, (state) => ({
    ...state,
    loading: true,
    error: null,
  })),
  on(DeviceActions.loadIdentitySuccess, (state, { identity }) => ({
    ...state,
    identity,
    connectionState: (identity.connectionState as 'Connected' | 'Disconnected') ?? null,
    loading: false,
  })),
  on(DeviceActions.loadIdentityFailure, (state, { error }) => ({
    ...state,
    loading: false,
    error,
  })),

  // Load Twin
  on(DeviceActions.loadTwin, (state) => ({
    ...state,
    loading: true,
    error: null,
  })),
  on(DeviceActions.loadTwinSuccess, (state, { twin }) => ({
    ...state,
    twin,
    loading: false,
  })),
  on(DeviceActions.loadTwinFailure, (state, { error }) => ({
    ...state,
    loading: false,
    error,
  })),

  // Update Connection State
  on(DeviceActions.updateConnectionState, (state, { connectionState }) => ({
    ...state,
    connectionState,
  })),

  // Direct Method
  on(DeviceActions.invokeDirectMethod, (state) => ({
    ...state,
    directMethodLoading: true,
    directMethodError: null,
    directMethodResult: null,
  })),
  on(DeviceActions.invokeDirectMethodSuccess, (state, { result }) => ({
    ...state,
    directMethodResult: result,
    directMethodLoading: false,
  })),
  on(DeviceActions.invokeDirectMethodFailure, (state, { error }) => ({
    ...state,
    directMethodLoading: false,
    directMethodError: error,
  })),
  on(DeviceActions.clearDirectMethodResult, (state) => ({
    ...state,
    directMethodResult: null,
    directMethodError: null,
  })),

  // C2D Message
  on(DeviceActions.sendC2DMessage, (state) => ({
    ...state,
    c2dSending: true,
    c2dError: null,
    c2dResult: null,
  })),
  on(DeviceActions.sendC2DMessageSuccess, (state, { result }) => ({
    ...state,
    c2dResult: result,
    c2dSending: false,
  })),
  on(DeviceActions.sendC2DMessageFailure, (state, { error }) => ({
    ...state,
    c2dSending: false,
    c2dError: error,
  })),
  on(DeviceActions.clearC2DResult, (state) => ({
    ...state,
    c2dResult: null,
    c2dError: null,
  })),

  // Telemetry
  on(DeviceActions.loadTelemetry, (state) => ({
    ...state,
    telemetryLoading: true,
    telemetryError: null,
  })),
  on(DeviceActions.loadTelemetrySuccess, (state, { messages }) => ({
    ...state,
    telemetryMessages: messages,
    telemetryLoading: false,
  })),
  on(DeviceActions.loadTelemetryFailure, (state, { error }) => ({
    ...state,
    telemetryLoading: false,
    telemetryError: error,
  })),
  on(DeviceActions.addTelemetryMessage, (state, { message }) => ({
    ...state,
    telemetryMessages: [message, ...state.telemetryMessages],
  })),
  on(DeviceActions.clearTelemetry, (state) => ({
    ...state,
    telemetryMessages: [],
    telemetryError: null,
  }))
);
